export default __webpack_public_path__ + "static/media/shrinkIcon.3ae04c9b.svg";